import { createModelStore } from '@/shared/stores/create-model-store'
import { model6InitialModel } from './initial-state'
import { model6DimensionHandlers } from './dimensions'

export const useModel6Store = createModelStore({
  initialModel: model6InitialModel,
  dimensionHandlers: model6DimensionHandlers,
})
